export default function DatenschutzPage() {
  return (
    <div className="bg-white" data-testid="datenschutz-page">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-normal text-[#2c3e50] mb-2">Datenschutzerklärung</h1>
        <hr className="mb-8 border-gray-300" />

        <div className="text-[#2c3e50] space-y-6 leading-relaxed text-sm">
          <p className="font-semibold text-base">A. Datenschutzerklärung nach der DSGVO</p>

          <div>
            <p className="font-semibold">I. Name und Anschrift des Verantwortlichen</p>
            <p className="mt-2">Der Verantwortliche im Sinne der Datenschutz-Grundverordnung und anderer nationaler Datenschutzgesetze der Mitgliedsstaaten sowie sonstiger datenschutzrechtlicher Bestimmungen ist die:</p>
            <p className="mt-2">
              Dipl.-Psych. Katharina Langer<br />
              Psychologische Psychotherapeutin<br />
              Butenwall 52A, 46325 Borken<br />
              Deutschland<br />
              Telefon: +49 15751336474<br />
              Fax: +49 15751336474<br />
              E-Mail: Psychotherapie-Praxis-langer@gmx.de<br />
              www.psychotherapie-praxis-langer.de
            </p>
          </div>

          <div>
            <p className="font-semibold">II. Name und Anschrift des Datenschutzbeauftragten</p>
            <p className="mt-2">Die Praxis hat keinen Datenschutzbeauftragten, da sie weniger als 10 Angestellte hat.</p>
          </div>

          <div>
            <p className="font-semibold">III. Allgemeines zur Datenverarbeitung</p>
            
            <p className="mt-2 font-medium">1. Umfang der Verarbeitung personenbezogener Daten</p>
            <p>Wir verarbeiten personenbezogene Daten unserer Nutzer grundsätzlich nur, soweit dies zur Bereitstellung einer funktionsfähigen Website sowie unserer Inhalte und Leistungen erforderlich ist. Die Verarbeitung personenbezogener Daten unserer Nutzer erfolgt regelmäßig nur nach Einwilligung des Nutzers. Eine Ausnahme gilt in solchen Fällen, in denen eine vorherige Einholung einer Einwilligung aus tatsächlichen Gründen nicht möglich ist und die Verarbeitung der Daten durch gesetzliche Vorschriften gestattet ist.</p>

            <p className="mt-4 font-medium">2. Rechtsgrundlage für die Verarbeitung personenbezogener Daten</p>
            <p>Soweit wir für Verarbeitungsvorgänge personenbezogener Daten eine Einwilligung der betroffenen Person einholen, dient Art. 6 Abs. 1 lit. a EU-Datenschutzgrundverordnung (DSGVO) als Rechtsgrundlage. Bei der Verarbeitung von personenbezogenen Daten, die zur Erfüllung eines Vertrages, dessen Vertragspartei die betroffene Person ist, erforderlich ist, dient Art. 6 Abs. 1 lit. b DSGVO als Rechtsgrundlage.</p>

            <p className="mt-4 font-medium">3. Datenlöschung und Speicherdauer</p>
            <p>Die personenbezogenen Daten der betroffenen Person werden gelöscht oder gesperrt, sobald der Zweck der Speicherung entfällt. Eine Speicherung kann darüber hinaus erfolgen, wenn dies durch den europäischen oder nationalen Gesetzgeber in unionsrechtlichen Verordnungen, Gesetzen oder sonstigen Vorschriften, denen der Verantwortliche unterliegt, vorgesehen wurde.</p>
          </div>

          <div>
            <p className="font-semibold">IV. Bereitstellung der Website und Erstellung von Logfiles</p>
            
            <p className="mt-2 font-medium">1. Beschreibung und Umfang der Datenverarbeitung</p>
            <p>Bei jedem Aufruf unserer Internetseite erfasst unser System automatisiert Daten und Informationen vom Computersystem des aufrufenden Rechners.</p>
            
            <p className="mt-2">Folgende Daten werden hierbei erhoben:</p>
            <ul className="list-disc pl-5 mt-1">
              <li>Informationen über den Browsertyp und die verwendete Version</li>
              <li>Das Betriebssystem des Nutzers</li>
              <li>Den Internet-Service-Provider des Nutzers</li>
              <li>Die IP-Adresse des Nutzers</li>
              <li>Datum und Uhrzeit des Zugriffs</li>
              <li>Websites, von denen das System des Nutzers auf unsere Internetseite gelangt</li>
              <li>Websites, die vom System des Nutzers über unsere Website aufgerufen werden</li>
            </ul>
          </div>

          <div>
            <p className="font-semibold">V. Verwendung von Cookies</p>
            <p className="mt-2">Unsere Webseite verwendet keine Cookies. Es werden daher auch keine Daten erhoben oder gespeichert.</p>
          </div>

          <div>
            <p className="font-semibold">VI. Newsletter</p>
            <p className="mt-2">Unsere Webseite bietet keinen Newsletter an. Es werden daher auch keine Daten erhoben oder gespeichert.</p>
          </div>

          <div>
            <p className="font-semibold">VII. Registrierung</p>
            <p className="mt-2">Auf unserer Webseite besteht keine Möglichkeit oder Notwendigkeit zur Registrierung. Es werden daher auch keine Daten erhoben oder gespeichert.</p>
          </div>

          <div>
            <p className="font-semibold">VIII. Kontaktformular und E-Mail-Kontakt</p>
            <p className="mt-2">Auf unserer Internetseite ist kein Kontaktformular vorhanden, welches für die elektronische Kontaktaufnahme genutzt werden kann. Es werden daher auch keine Daten erhoben oder gespeichert.</p>
          </div>

          <div>
            <p className="font-semibold">IX. Webanalyse</p>
            <p className="mt-2">Unsere Internetseite benutzt keine Webanalyse wie Google Analytics u.a. Es werden daher auch keine Daten erhoben, gespeichert oder verarbeitet.</p>
          </div>

          <div>
            <p className="font-semibold">X. Rechte der betroffenen Person</p>
            <p className="mt-2">Werden personenbezogene Daten von Ihnen verarbeitet, sind Sie Betroffener i.S.d. DSGVO und es stehen Ihnen folgende Rechte gegenüber dem Verantwortlichen zu:</p>
            
            <p className="mt-2 font-medium">1. Auskunftsrecht</p>
            <p>Sie können von dem Verantwortlichen eine Bestätigung darüber verlangen, ob personenbezogene Daten, die Sie betreffen, von uns verarbeitet werden.</p>
            
            <p className="mt-2 font-medium">2. Recht auf Berichtigung</p>
            <p>Sie haben ein Recht auf Berichtigung und/oder Vervollständigung gegenüber dem Verantwortlichen, sofern die verarbeiteten personenbezogenen Daten, die Sie betreffen, unrichtig oder unvollständig sind.</p>
            
            <p className="mt-2 font-medium">3. Recht auf Einschränkung der Verarbeitung</p>
            <p>Unter bestimmten Voraussetzungen können Sie die Einschränkung der Verarbeitung der Sie betreffenden personenbezogenen Daten verlangen.</p>
            
            <p className="mt-2 font-medium">4. Recht auf Löschung</p>
            <p>Sie können von dem Verantwortlichen verlangen, dass die Sie betreffenden personenbezogenen Daten unverzüglich gelöscht werden.</p>
            
            <p className="mt-2 font-medium">5. Recht auf Unterrichtung</p>
            <p>Haben Sie das Recht auf Berichtigung, Löschung oder Einschränkung der Verarbeitung gegenüber dem Verantwortlichen geltend gemacht, ist dieser verpflichtet, allen Empfängern diese mitzuteilen.</p>
            
            <p className="mt-2 font-medium">6. Recht auf Datenübertragbarkeit</p>
            <p>Sie haben das Recht, die Sie betreffenden personenbezogenen Daten in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten.</p>
            
            <p className="mt-2 font-medium">7. Widerspruchsrecht</p>
            <p>Sie haben das Recht, aus Gründen, die sich aus ihrer besonderen Situation ergeben, jederzeit gegen die Verarbeitung Widerspruch einzulegen.</p>
            
            <p className="mt-2 font-medium">8. Recht auf Widerruf der datenschutzrechtlichen Einwilligungserklärung</p>
            <p>Sie haben das Recht, Ihre datenschutzrechtliche Einwilligungserklärung jederzeit zu widerrufen.</p>
            
            <p className="mt-2 font-medium">9. Recht auf Beschwerde bei einer Aufsichtsbehörde</p>
            <p>Unbeschadet eines anderweitigen verwaltungsrechtlichen oder gerichtlichen Rechtsbehelfs steht Ihnen das Recht auf Beschwerde bei einer Aufsichtsbehörde zu.</p>
          </div>

          <div>
            <p className="font-semibold">XI. Pflichten der betroffenen Person</p>
            <p className="mt-2 font-medium">1. Keine Abmahnung ohne Kontakt!</p>
            <p>Im Falle der Geltendmachung von Ansprüchen jeglicher Art aus Urheber-, wettbewerbsrechtlichen sowie markenrechtlichen und datenrechtlichen Angelegenheiten bitte ich, zur Vermeidung unnötiger Rechtsstreitigkeiten, Abmahnungen und Kosten, mich umgehend zu kontaktieren.</p>
          </div>

          <div>
            <p className="font-semibold">XII. Salvatorische Klausel</p>
            <p className="mt-2">Sofern Teile oder einzelne Formulierungen dieses Textes der geltenden Rechtslage nicht, nicht mehr oder nicht vollständig entsprechen sollten, bleiben die übrigen Teile des Dokumentes in ihrem Inhalt und ihrer Gültigkeit davon unberührt.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
